import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Bill } from "src/app/shared/types/contract-types";

import { ActivatedRoute, Router } from "@angular/router";
import { toggleAnimation } from "src/app/shared/animations";
import { ContractService } from "src/app/shared/services/contract.service";
import { UserRoles } from "src/app/shared/enums/user-roles";

@Component({
  templateUrl: "./contract-edit.component.html",
  animations: [toggleAnimation],
  standalone: false,
})
export class ContractEditComponent implements OnInit {
  activeTab = "contract-details";

  billsArray: Bill[] = [];

  packageId = 0;
  paramId = 0;
  apiKey!: string;

  userSettingsForm!: FormGroup;
  agencySettingsForm!: FormGroup;
  billsForm!: FormGroup;
  instancesForm!: FormGroup;
  userRole = UserRoles;
  isLoading = false;

  configForm!: FormGroup;
  constructor(
    public translate: TranslateService,
    private contractService: ContractService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((param) => {
      const id = param.get("id");
      this.paramId = id ? Number.parseInt(id) : 0;
      this.isLoading = true;
      const getSub = this.contractService
        .getContractById(this.paramId)
        .subscribe((res) => {
          getSub.unsubscribe();
          this.isLoading = false;
          this.packageId = res?.package?.id;
          this.apiKey = res.apiKey;
        });
    });

    this.route.fragment.subscribe((fragment: string | null) => {
      if (fragment) {
        this.activeTab = fragment;
      }
      else {
        this.router.navigate([], {
          relativeTo: this.route,
          fragment: "contract-details",
          replaceUrl: true,
        });
      }
    });
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: tab,
      replaceUrl: false,
    });
  }
}
